import React from 'react';
import styled from "styled-components";
import { theme } from "../theme";
const ThemeWrapper = styled.div`
  position: relative;
  }
`;

export function withTheme(WrappedComponent) {
  return function (props) {
    return (
      <ThemeWrapper>
        <WrappedComponent {...props} />
      </ThemeWrapper>
    );
  };
}
